import { Component } from '@angular/core';

@Component({
    template: '<h3 class="text-center mt-5">Página no encontrada</h3>',
})
export class NotFoundComponent {

}
